import { combineReducers } from 'redux';

import { poolListReducer } from './listModule';

const poolReducer = combineReducers({
	list: poolListReducer,
});

export default poolReducer;
